// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__16NW6","dragIcon":"SortableItem_dragIcon__1ei-s","disabled":"SortableItem_disabled__3C8t0"};